export default "__VITE_ASSET__Bn$CeSqG__"